// material-ui
import { useTheme } from '@mui/material/styles';
import logo from 'assets/images/logo_blanco.png';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    const theme = useTheme();

    return <img style={{ width: '50' }} src={logo} alt="HRxHR" width="50" />;
};

export default Logo;
